import { BaseInput } from "@/components/input/CustomInputs";
import { formInterface } from "@/interface/dataInterface";
import { FC } from "react";

const TaxiClientForm: FC<formInterface> = ({ formProp, setFormProp }) => {
  return (
    <div className="grid gap-y-4">
      <BaseInput
        id="name"
        label="Full name"
        value={formProp.name}
        setProp={setFormProp}
        placeholder="Client full name"
      />
      <BaseInput
        id="phone_number"
        label="Phone number"
        value={formProp.phone_number}
        setProp={setFormProp}
        placeholder="Client phone number"
      />
      <BaseInput
        id="home_address"
        label="Home address"
        value={formProp.home_address}
        setProp={setFormProp}
        placeholder="Client home address"
        required={false}
      />
    </div>
  );
};

export default TaxiClientForm;
